const route = {
	path: ':customerId?/companies/:subsidiaryId/accounting-parametrization',
	name: 'accounting-parametrization',
	meta: {
		title: 'Datos Iniciales Contables',
	},
	component: () => import('@/pages/accounting-parametrizations/page-accounting-parametrization'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-parametrization.js